module.exports = __webpack_public_path__ + "img/phone-screen-erik-3.56ad904c.jpg";